// extracted by mini-css-extract-plugin
export default {"mainCont":"report_mainCont__xmFNd"};